import { useField } from "formik";
import Styles from "./SignupForm.module.css";



const CustomSelect = ({ label, options, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<>
			<div className={Styles.customSelect}>
				<label className={Styles.label}>{label}</label>
				<div>
					{options.map((option) => (
						<label key={option.value}>
							<input
								className={Styles.input}
								type='radio'
								{...field}
								{...props}
								value={option.value}
								checked={field.value === option.value}
							/>
							<span className={Styles.selectLabel}>
								{option.label}
							</span>
						</label>
					))}
				</div>
			{meta.touched && meta.error && (
				<div className={Styles.error}>Choose one</div>
			)}
			</div>
		</>
	);
};
export default CustomSelect;
